<template>
  <div class="bg-white pb-12 sm:pb-14">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="flex justify-center">
        <RadioGroup v-model="frequency" class="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200">
          <RadioGroupLabel class="sr-only">
            Abo
          </RadioGroupLabel>
          <RadioGroupOption as="template" v-for="option in frequencies" :key="option.value" :value="option" v-slot="{ checked }">
            <div :class="[checked ? 'bg-teal-600 text-white' : 'text-gray-500', 'cursor-pointer rounded-full px-2.5 py-1']">
              <span>
                {{ option.label }}
              </span>
            </div>
          </RadioGroupOption>
        </RadioGroup>
      </div>
      <div v-if="success" class="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <div v-for="tier in results" :key="tier.id" :class="[tier.promo ? 'ring-2 ring-teal-600' : 'ring-1 ring-gray-200', 'rounded-3xl p-8 xl:p-10']">
          <div class="flex items-center justify-between gap-x-4">
            <h3 :id="tier.id" :class="[tier.promo ? 'text-teal-700' : 'text-gray-800', 'text-lg font-semibold leading-8']">
              {{ tier.name }}
            </h3>
          </div>
          <div class="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch">
            <div class="mt-2 flex items-center gap-x-4">
              <p v-if="monthly" :class="[tier.promo ? 'text-gray-900' : 'text-gray-600', 'text-4xl font-bold tracking-tight']">
                {{ tier.monthly }}
              </p>
              <p v-if="annual" :class="[tier.promo ? 'text-gray-900' : 'text-gray-600', 'text-4xl font-bold tracking-tight']">
                {{ tier.annual }}
              </p>
              <div class="text-sm leading-5">
                <p :class="tier.promo ? 'text-gray-900' : 'text-gray-600'">
                  EURO
                </p>
                <p :class="tier.promo ? 'text-gray-500' : 'text-gray-400'">
                  {{ frequency.details }}
                </p>
              </div>
            </div>
            <a :href="steady(tier)" target="_blank" :aria-describedby="tier.id" :class="[tier.promo ? 'bg-teal-700 text-white shadow-sm hover:bg-teal-500 focus-visible:outline-teal-600' : 'bg-white text-teal-600 ring-1 ring-inset ring-teal-600 hover:ring-teal-400', 'rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2']">
              Via Steady abonnieren
            </a>
          </div>
          <ul role="list" class="mt-8 space-y-3 text-sm leading-6 text-gray-600 xl:mt-10">
            <li v-for="feature in tier.features" :key="feature" class="flex gap-x-3">
              <CheckIcon class="h-6 w-5 flex-none text-teal-600" aria-hidden="true" />
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { RadioGroup } from '@headlessui/vue';
import { RadioGroupLabel } from '@headlessui/vue';
import { RadioGroupOption } from '@headlessui/vue';
import { CheckIcon } from '@heroicons/vue/20/solid';
import { useFetchResources } from '@/client/actions';
import { frequencies } from '@/static/enums';

const FREQUENCY_MONTHLY = 'monthly';
const FREQUENCY_ANNUAL = 'annual';

const frequency = ref(frequencies[0]);
const monthly = computed(() => frequency.value.value === FREQUENCY_MONTHLY);
const annual = computed(() => frequency.value.value === FREQUENCY_ANNUAL);

const target = computed(() => '/api/offerings:paid');
const action = useFetchResources(target);

const { results, fetching, fetch, success } = action;

const mounted = onMounted(() => fetch());
const watcher = watch(target, (v, _) => fetch());

const steady = (tier) =>
{
    const url = new URL(tier.steady);
    const freq = frequency.value.value;
    url.searchParams.append('period', freq);
    return url;
};
</script>
